module.exports = __webpack_public_path__ + "img/img-d515e1.png";